// components/LogoutButton.jsx
import React, { useState } from 'react';
import { useLogout } from '../../hooks/useLogout';

const LogoutButton = ({ 
    variant = 'button',
    className = 'btn-default',
    showConfirm = true,
    onLogoutStart,
    onLogoutComplete,
    children 
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const { logout } = useLogout();

    const handleLogout = async () => {
        if (isLoading) return;
        
        // Optional: Show confirmation dialog
        if (showConfirm) {
            const confirmed = window.confirm('Are you sure you want to logout?');
            if (!confirmed) return;
        }
        
        setIsLoading(true);
        
        // Callback before logout
        if (onLogoutStart) onLogoutStart();
        
        try {
            await logout();
            
            // Callback after successful logout
            if (onLogoutComplete) onLogoutComplete();
            
        } catch (error) {
            console.error('Logout error:', error);
            // Optional: Show error to user
            alert('Logout failed. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    // Different button styles
    const renderButton = () => {
        const baseClasses = `logout-btn ${className} ${isLoading ? 'loading' : ''}`;
        
        switch(variant) {
            case 'link':
                return (
                    <a 
                        href="#logout" 
                        onClick={(e) => {
                            e.preventDefault();
                            handleLogout();
                        }}
                        className={baseClasses}
                    >
                        {isLoading ? 'Logging out...' : (children || 'Logout')}
                    </a>
                );
            
            case 'icon':
                return (
                    <button
                        onClick={handleLogout}
                        disabled={isLoading}
                        className={baseClasses}
                        aria-label="Logout"
                        title="Logout"
                    >
                        {isLoading ? '⋯' : '🚪'}
                    </button>
                );
            
            default:
                return (
                    <button
                        onClick={handleLogout}
                        disabled={isLoading}
                        className={baseClasses}
                    >
                        {isLoading ? 'Logging out...' : (children || 'Logout')}
                    </button>
                );
        }
    };

    return renderButton();
};

export default LogoutButton;